/* ==========================================================================
   interactions.js — acordeón, bloques clicables y estados hover
   ========================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------------
     1. Acordeón (PageFly Accordion3)
     El CSS anima con `grid-template-rows: 0fr -> 1fr` sobre
     `.pf-accordion-wrap.open > .pf-accordion-body` (300 ms).
     `<details>` debe abrirse antes de animar y cerrarse después de animar.
     `data-open-multiple="false"` cierra los hermanos.
     ------------------------------------------------------------------ */
  var ACC_MS = 300;

  function closeItem(item) {
    if (!item.classList.contains('open')) { item.open = false; return; }
    item.classList.remove('open');
    var header = item.querySelector('.pf-accordion-header');
    if (header) header.setAttribute('data-active', 'false');
    setTimeout(function () {
      if (!item.classList.contains('open')) item.open = false;
    }, ACC_MS);
  }

  function openItem(item) {
    item.open = true;
    var header = item.querySelector('.pf-accordion-header');
    if (header) header.setAttribute('data-active', 'true');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { item.classList.add('open'); });
    });
  }

  function initAccordions() {
    document.querySelectorAll('.pf-accordion').forEach(function (group) {
      var multiple = group.getAttribute('data-open-multiple') === 'true';
      var scrollTop = group.getAttribute('data-scroll-to-top') === 'true';
      var items = group.querySelectorAll(':scope > details');

      items.forEach(function (item) {
        var summary = item.querySelector(':scope > summary');
        if (!summary) return;
        if (item.open) item.classList.add('open');

        summary.addEventListener('click', function (e) {
          e.preventDefault();
          var willOpen = !item.classList.contains('open');
          if (willOpen && !multiple) {
            items.forEach(function (other) { if (other !== item) closeItem(other); });
          }
          if (willOpen) {
            openItem(item);
            if (scrollTop) {
              setTimeout(function () {
                item.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }, ACC_MS);
            }
          } else {
            closeItem(item);
          }
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     2. Bloques clicables: `[data-href]` + `[data-target]`
     PageFly hace el bloque entero navegable (el CSS ya pone cursor:pointer
     mediante `.__pf [data-href]`).
     ------------------------------------------------------------------ */
  function initClickable() {
    document.addEventListener('click', function (e) {
      /* Sólo ceder ante elementos con su propia acción: enlaces con href real, botones/controles.
         Los <a class="pf-button-b"> de PageFly son cascarones sin href dentro de bloques [data-href];
         no deben bloquear la navegación del bloque (por eso "Todos los accesorios" / "Ver ..." no iban). */
      var realLink = e.target.closest('a[href]');
      if (realLink) { var rh = realLink.getAttribute('href'); if (rh && rh.charAt(0) !== '#') return; }
      if (e.target.closest('button, input, label, summary, select, textarea, [data-djimx-atc], [data-action="popup-element"]')) return;
      var el = e.target.closest('[data-href]');
      if (!el) return;
      var href = el.getAttribute('data-href');
      if (!href) return;
      var target = el.getAttribute('data-target') || '_self';
      if (target === '_blank') window.open(href, '_blank', 'noopener');
      else window.location.href = href;
    });

    /* accesibilidad: Enter/Espacio sobre un bloque enfocado */
    document.querySelectorAll('[data-href]').forEach(function (el) {
      if (el.hasAttribute('tabindex')) return;
      el.setAttribute('tabindex', '0');
      el.setAttribute('role', 'link');
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); el.click(); }
      });
    });
  }

  /* ------------------------------------------------------------------
     3. Formularios de producto: la réplica es estática, no hay carrito.
     Se evita el POST a /cart/add manteniendo el estado visual del botón.
     ------------------------------------------------------------------ */
  function initForms() {
    document.querySelectorAll('form.pf-product-form').forEach(function (form) {
      form.addEventListener('submit', function (e) { e.preventDefault(); });
    });
  }

  /* ------------------------------------------------------------------
     4. Estado agotado de los botones «Agregar al carrito»
     El HTML servido trae siempre el texto normal; PageFly lo sustituye en
     runtime por el de `data-soldout` («Proximamente») y pone `disabled`
     cuando el producto no tiene ninguna variante disponible.
     La lista sale de window.__pageflyProducts del propio sitio (pf-config.js).
     El CSS `.pf-product-atc[disabled]{opacity:.7}` ya viene del sitio.
     ------------------------------------------------------------------ */
  function initSoldOut() {
    var ids = window.PF_SOLD_OUT;
    if (!ids || !ids.length) return;
    var set = {};
    for (var i = 0; i < ids.length; i++) set[ids[i]] = true;
    document.querySelectorAll('button[data-soldout][data-product-id]').forEach(function (btn) {
      if (!set[btn.getAttribute('data-product-id')]) return;
      btn.textContent = btn.getAttribute('data-soldout');
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
    });
  }

  /* ------------------------------------------------------------------
     5. Lazy videos — category cards + Osmo hero slide
     Markup ships without src/autoplay so below-fold MP4s (~10MB) stay off
     the critical path. IntersectionObserver assigns src and plays when
     visible; hero videos only activate the matching breakpoint.
     ------------------------------------------------------------------ */
  function armVideo(video) {
    if (!video || video.getAttribute('data-djimx-armed') === '1') return;
    var raw = video.getAttribute('data-src') || '';
    if (!raw && !video.getAttribute('src')) return;
    video.setAttribute('data-djimx-armed', '1');
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    /* preload=none never fetches until play(), and play() was waiting on
       loadeddata — that loop leaves a blank (white) frame on mobile. */
    video.preload = 'auto';

    var attempt = parseInt(video.getAttribute('data-djimx-attempt') || '0', 10) + 1;
    video.setAttribute('data-djimx-attempt', String(attempt));
    /* #t=0.1 is a poster-frame hack that stalls the first request on mobile,
       leaving a blank video under white copy. Load the file itself. */
    var src = (raw || video.getAttribute('src') || '').split('#')[0];
    var token = String(Date.now()) + ':' + attempt;
    video.setAttribute('data-djimx-token', token);

    function stale() { return video.getAttribute('data-djimx-token') !== token; }
    function play() {
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }
    function markReady() {
      if (stale()) return;
      video.setAttribute('data-djimx-ready', '1');
      video.removeAttribute('data-djimx-failed');
    }
    function retry() {
      if (stale() || attempt >= 2) {
        if (!stale() && video.getAttribute('data-djimx-ready') !== '1') {
          video.setAttribute('data-djimx-failed', '1');
        }
        return;
      }
      video.removeAttribute('data-djimx-armed');
      video.removeAttribute('src');
      try { video.load(); } catch (e) {}
      armVideo(video);
    }

    video.addEventListener('loadeddata', function () { markReady(); play(); }, { once: true });
    video.addEventListener('playing', markReady, { once: true });
    video.addEventListener('error', function () { retry(); }, { once: true });

    if (src && video.getAttribute('src') !== src) video.src = src;
    play();

    window.setTimeout(function () {
      if (stale() || video.getAttribute('data-djimx-ready') === '1') return;
      if (video.readyState >= 2) { markReady(); play(); return; }
      if (video.networkState === 2) { play(); return; }
      retry();
    }, 8000);
  }

  function disarmVideo(video) {
    if (!video || !video.src) return;
    video.setAttribute('data-djimx-token', '');
    try { video.pause(); } catch (e) {}
    video.removeAttribute('src');
    video.removeAttribute('data-djimx-armed');
    video.removeAttribute('data-djimx-ready');
    try { video.load(); } catch (e2) {}
  }

  function initLazyVideos() {
    var mq = window.matchMedia('(max-width: 767.4999px)');
    function activeHeroKey() { return mq.matches ? 'mobile' : 'desktop'; }

    function syncHeroVideos(root) {
      var key = activeHeroKey();
      (root || document).querySelectorAll('[data-djimx-hero-video]').forEach(function (v) {
        var want = v.getAttribute('data-djimx-hero-video') === key;
        var slide = v.closest('.pf-slide');
        var visible = !slide || slide.getBoundingClientRect().width > 8;
        if (want && visible) armVideo(v);
        else disarmVideo(v);
      });
    }

    var targets = document.querySelectorAll('[data-djimx-lazy-video], [data-djimx-hero-video]');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (v) {
        if (v.hasAttribute('data-djimx-hero-video')) return;
        armVideo(v);
      });
      syncHeroVideos();
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (v.hasAttribute('data-djimx-hero-video')) {
          if (entry.isIntersecting) syncHeroVideos(v.closest('.dji-osmo-slide') || document);
          else disarmVideo(v);
          return;
        }
        if (entry.isIntersecting) {
          armVideo(v);
          io.unobserve(v);
        }
      });
    }, { rootMargin: '200px 0px', threshold: 0.01 });

    targets.forEach(function (v) { io.observe(v); });
    syncHeroVideos();
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', function () { syncHeroVideos(); });
    else if (typeof mq.addListener === 'function') mq.addListener(function () { syncHeroVideos(); });
  }

  function init() {
    /* PageFly owns Accordion3 click/state handling. Registering a second
       summary listener causes data-active to flip back during the first
       click, requiring a second click to open the panel. */
    initClickable();
    initForms();
    initSoldOut();
    initLazyVideos();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
